import { gql } from "@apollo/client"

export interface TerminalOwnershipInput {
  id: number
}

export interface AddUserInput {
  email: string
  role: "Admin" | "Viewer"
}

export const CREATE_ORGANIZATION_GROUP = gql`
  mutation createOrgGroup($name: String!, $organizationId: ID!, $terminalIds: [TerminalInput], $users: [AddUserInput]) {
    createGroup(name: $name, organizationId: $organizationId, terminalIds: $terminalIds, users: $users) {
      createdGroup {
        id
        name
        terminals {
          id
        }
      }
      errors
    }
  }
`
